import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import PDFViewerForCases from '../containers/Onboarding/PDFViewerForCases';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import SubjectIcon from '@material-ui/icons/Subject';
import axios from 'axios';

const styles = theme => ({
    container: {
        width: '100%',
        // display: 'flex',
        // flexWrap: 'wrap',
        display: 'table-cell',
        textAlign: 'center',
        verticalAlign: 'middle',
    },
    root: {
        marginLeft: theme.spacing.unit,
        marginBottom: '6px',
        width: '100%',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '300px',
      },
      button: {
        //margin: theme.spacing.unit,
      },
    card: {
        minWidth: 250,
        width: 400,
        height: 200,
        marginRight: 6,
        marginBottom: 6,
    
    },
    table: {
        width: '100%',
    },
    link: {
        textDecoration: 'none',
      },
    header:{
            fontSize: 13,
    },
    row:{
        fontSize: 12
    },
});

class UploadedDoc extends Component  {
    constructor(props) {
        super(props);
    }
    state = {
        file: null,
        doc_name: null,
        open: false,
        fileUrl: '',
        summaryOpen: false,
        summaryText: '',
        summaryDocName: '',
        aiStatusOverrides: {},
    }

    handleClickOpen = (fileUrl) => {
        console.log('UPPfileUrl', fileUrl);
        this.setState({ open: true, fileUrl: fileUrl });
    };

    handleClose = (value) => {
        this.setState({ open: false, fileUrl: '' });
    };

    uploadFile = (event) => {

    }
    
    handleReset = (event, filename) => {
        
    }

    handleMarkForAI = (row) => {
        const { caseId, docType } = this.props;
        if (!caseId || !docType) return;

        const prevAiData = this.state.aiStatusOverrides[row.filename] || {};

        this.setState(prevState => ({
            aiStatusOverrides: {
                ...prevState.aiStatusOverrides,
                [row.filename]: { ...prevAiData, aiStatus: 'pending' }
            }
        }));

        let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/markDocForAIProcessing`;
        axios.post(url, { caseId, filename: row.filename, docType })
            .then(response => {
                if (!response.data || !response.data.success) {
                    this.setState(prevState => {
                        const overrides = { ...prevState.aiStatusOverrides };
                        if (prevAiData.aiStatus) {
                            overrides[row.filename] = prevAiData;
                        } else {
                            delete overrides[row.filename];
                        }
                        return { aiStatusOverrides: overrides };
                    });
                }
            })
            .catch(err => {
                console.error('Error marking doc for AI processing', err);
                this.setState(prevState => {
                    const overrides = { ...prevState.aiStatusOverrides };
                    if (prevAiData.aiStatus) {
                        overrides[row.filename] = prevAiData;
                    } else {
                        delete overrides[row.filename];
                    }
                    return { aiStatusOverrides: overrides };
                });
            });
    }

    handleMarkAllForAI = () => {
        const { caseId, docType, rows } = this.props;
        if (!caseId || !docType || !rows) return;

        rows.forEach(row => {
            if (!row.filename) return;
            this.setState(prevState => ({
                aiStatusOverrides: {
                    ...prevState.aiStatusOverrides,
                    [row.filename]: {
                        ...(prevState.aiStatusOverrides[row.filename] || {}),
                        aiStatus: 'pending'
                    }
                }
            }));

            const url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/markDocForAIProcessing`;
            axios.post(url, { caseId, filename: row.filename, docType })
                .catch(err => {
                    console.error('Error marking doc for AI processing', err);
                });
        });
    }

    handleOpenSummary = (docName, summaryText) => {
        this.setState({ summaryOpen: true, summaryText, summaryDocName: docName });
    }

    renderAICell = (row) => {
        const { caseId, docType } = this.props;
        const aiOverride = this.state.aiStatusOverrides[row.filename];
        const aiStatus = aiOverride !== undefined ? aiOverride.aiStatus : row.aiStatus;
        const aiSummary = aiOverride !== undefined ? aiOverride.processedData : row.processedData;
        const isPending = aiStatus === 'pending';
        const isProcessed = aiStatus === 'completed';

        return (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '2px' }}>
                <Tooltip title={isPending ? 'Marked for AI Processing' : 'Mark for AI Processing'}>
                    <Button
                        size="small"
                        variant="outlined"
                        onClick={() => this.handleMarkForAI(row)}
                        disabled={!caseId || !docType}
                        style={{
                            fontSize: '10px',
                            padding: '1px 5px',
                            minWidth: 'unset',
                            lineHeight: 1.4,
                            color: isPending ? '#ff9800' : '#1976d2',
                            borderColor: isPending ? '#ff9800' : '#1976d2',
                        }}
                    >
                        {isPending ? '⏳ AI' : 'AI'}
                    </Button>
                </Tooltip>
                {isProcessed && aiSummary && (
                    <Tooltip title="View AI Summary">
                        <IconButton
                            onClick={() => this.handleOpenSummary(row.doc_name, aiSummary)}
                            style={{ padding: '2px', color: '#4caf50' }}
                        >
                            <SubjectIcon style={{ fontSize: '16px' }} />
                        </IconButton>
                    </Tooltip>
                )}
            </span>
        );
    }
    
    handleChange = prop => event => {
        this.setState({ [prop]: event.target.value });
    };

    getDisplayFileName = (name) => {
        var parts = (''+name).split('.');
        var fileFormat = '.' + parts.pop();
        var baseFileName = parts.join('.'); 
        baseFileName = baseFileName.split('##__##')[0];
        var file_name = baseFileName + fileFormat;
        return file_name;
    }

    formatDate = (isoString) => {
        if (!isoString) return '';
        try {
            const d = new Date(isoString);
            if (isNaN(d.getTime())) return '';
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            const hours = String(d.getHours()).padStart(2, '0');
            const minutes = String(d.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}`;
        } catch (e) {
            return '';
        }
    }

    render(){
        const { classes, rows } = this.props;
        const typeOfAccount = localStorage.getItem('typeOfAccount');
        const isAdminOrArbitrator = typeOfAccount === 'admin' || typeOfAccount === 'arbitrator';
        return (
            <div className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                    <TableRow style={{height: 16}}>
                        <TableCell className={classes.header} style={{width: '50px'}}></TableCell>
                        <TableCell className={classes.header} align="left" style={{width: '30%'}}></TableCell>
                        <TableCell className={classes.header} align="left" style={{width: 'auto'}}>{this.context.t('File')}</TableCell>
                        <TableCell className={classes.header} align="left" style={{width: '140px'}}>{this.context.t('Uploaded Date')}</TableCell>
                        
                        {/* {isAdminOrArbitrator && (
                            <TableCell className={classes.header} align="center" style={{width: '100px'}}>
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                    AI
                                    <Tooltip title="Mark all documents for AI Processing">
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            onClick={this.handleMarkAllForAI}
                                            disabled={!this.props.caseId || !this.props.docType}
                                            style={{
                                                fontSize: '9px',
                                                padding: '0px 4px',
                                                minWidth: 'unset',
                                                lineHeight: 1.4,
                                                color: '#1976d2',
                                                borderColor: '#1976d2',
                                            }}
                                        >
                                            All
                                        </Button>
                                    </Tooltip>
                                </span>
                            </TableCell>
                        )} */}
                    </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            rows && rows.map((row, index) => (
                                <TableRow key={index} hover style={{height: 16}}>
                                    <TableCell className={classes.row} component="th" scope="row" style={{width: '50px'}}>
                                        {index+1}
                                    </TableCell>
                                    <TableCell className={classes.row} align="left" style={{width: '30%'}}>
                                        {row.doc_name}
                                    </TableCell>
                                    <TableCell className={classes.row} align="left" style={{width: 'auto'}}>

                                        {(''+row.filename).includes('pdf') &&
                                        <span onClick={() => this.handleClickOpen('https://www.hkarbsoc.org.hk:9000/getUploadedDoc/?id=' + encodeURIComponent(row.filename))}
                                            className={classes.link}>
                                            <a>{this.getDisplayFileName(row.filename)}</a>
                                        </span>}

                                        {(!(''+row.filename).includes('pdf')) &&
                                        <a  target='_blank'
                                            href={'https://www.hkarbsoc.org.hk:9000/getUploadedDoc/?id=' + encodeURIComponent(row.filename)}
                                            className={classes.link}
                                        >
                                            {this.getDisplayFileName(row.filename)}
                                        </a>}
                                    </TableCell>
                                    <TableCell className={classes.row} align="left" style={{width: '140px'}}>
                                        {this.formatDate(row.createdAt)}
                                    </TableCell>
                                    {/* {isAdminOrArbitrator && (
                                        <TableCell className={classes.row} align="center" style={{width: '100px'}}>
                                            {this.renderAICell(row)}
                                        </TableCell>
                                    )} */}
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
                <Dialog
                    fullScreen
                    maxWidth= 'lg'
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    >
                    <Button 
                        onClick={() => this.handleClose()} 
                        color="primary" 
                        style={{ fontSize: 12 }}
                        autoFocus>
                        {this.context.t('Close')}
                    </Button>
                    <PDFViewerForCases isDesktop={this.props.isDesktop} file={this.state.fileUrl} fileURLNoName={this.state.fileUrl} />
                </Dialog>
                <Dialog
                    maxWidth="md"
                    fullWidth
                    open={this.state.summaryOpen}
                    onClose={() => this.setState({ summaryOpen: false })}
                    aria-labelledby="summary-dialog-title"
                >
                    <Button
                        onClick={() => this.setState({ summaryOpen: false })}
                        color="primary"
                        style={{ fontSize: 12 }}
                        autoFocus>
                        {this.context.t('Close')}
                    </Button>
                    <div style={{ padding: '0 20px 24px' }}>
                        <div style={{ fontSize: 14, fontWeight: 'bold', marginBottom: 12 }}>
                            {this.state.summaryDocName} — AI Summary
                        </div>
                        <div style={{ fontSize: 13, lineHeight: 1.7 }}
                            dangerouslySetInnerHTML={{ __html: this.state.summaryText }}
                        />
                    </div>
                </Dialog>
            </div>
        );
    }
}

UploadedDoc.contextTypes = {
    t: PropTypes.func
  }

export default withStyles(styles)(UploadedDoc);